import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/useUserStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

export const useUser = () => {
  const userStore = useUserStore();
  const viewerItemStore = useViewerItemStore();
  const { id: userId } = storeToRefs(userStore);
  const { userId: itemUserId } = storeToRefs(viewerItemStore);

  const isCurrentItemOwner = computed(() => userId?.value === itemUserId.value);

  return { isCurrentItemOwner };
};
